import { createRouter, createWebHistory } from "vue-router";

import ApolloSyncChildren from "./apollo-sync-front/childrens";

import { useAuth, useOidcStore } from "vue3-oidc";
import { useUserStore } from "@/store/user.js";
import { getFreshAccessToken } from "@/setup/api/getAccessToken.js";

const OidcCallback = () => import("@/components/OidcCallback.vue");
const ApolloSyncFront = () => import("@/components/ApolloSyncFront.vue");

const { autoAuthenticate, setRedirectUri } = useAuth();
const oidcStore = useOidcStore();

const routes = [
  {
    path: "/",
    component: ApolloSyncFront,
    children: ApolloSyncChildren,
    async beforeEnter() {
      const userStore = useUserStore();
      try {
        await userStore.fetchCurrentUser();
      } catch (error) {
        console.error("Failed to fetch current user:", error);
      }
    },
  },
  {
    path: "/oidc-callback", // Needs to match redirect_uri in you oidcSettings
    name: "oidcCallback",
    component: OidcCallback,
    meta: {
      isPublic: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.isPublic) {
    next();
    return;
  }

  // Silent refresh if the token is expired/expiring. Shared logic with the
  // API clients: getFreshAccessToken() performs the signinSilent + setUser.
  await getFreshAccessToken();

  const user = oidcStore.state.value.user;
  const isExpired = oidcStore.state.value.hasExpiresAt;

  if (!user || isExpired) {
    setRedirectUri(to.fullPath);
    try {
      await autoAuthenticate(to.fullPath);
    } catch (err) {
      console.error("Auto-authenticate error:", err);
    }
  }

  next();
});

export default router;
